import React, { useEffect } from "react";
import { useTheme } from "@mui/material";

import DefaultLink from "../../components/link/DefaultLink";
import UserContainer from "../../components/layout/container/UserContainer";
import SimpleBox from "../../components/layout/container/SimpleBox";
import { logout } from "../../helpers/firebase";

const Logout = () => {

    const theme = useTheme();

    useEffect(() => {
        logout().then(() => { });
    }, []);

    return (
        <UserContainer
            title="Sair"
            message="Obrigado! Volte a entrar em qualquer altura. Pode continuar a navegar no nosso site."
            checkUid={false}
        >
            <SimpleBox mt={theme.spacing(6)} justifyContent="center">
                <DefaultLink label="Entrar" to="/login" fontSize="1.1rem" allCaps={true} />
            </SimpleBox>
        </UserContainer>
    );
};

export default Logout;
